// Горната лента на дневника: назад към „Мониторинг", бранд, заглавие с мета,
// презареждане и профилът.
//
// Височината и отстъпите са същите като на всяка друга страница
// (`min-h-12 / min-h-[60px]`) — потребителят сравнява екраните един до друг.

import { useNavigate } from "react-router-dom";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import BackButton from "../../../../components/BackButton";
import ProfileDropdown from "../../../../components/ProfileDropdown";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { logout } from "../../../../store/authSlice";

type Props = {
  isNarrow: boolean;
  isFetching: boolean;
  onRefresh: () => void;
};

export const AuditTopBar = ({ isNarrow, isFetching, onRefresh }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const names = useAppSelector((state) => state.auth.names);
  const username = useAppSelector((state) => state.auth.username);
  const access = useAppSelector((state) => state.auth.access);
  const displayName = names || username || "";

  // Одитът е само за личен профил на админа — тук няма споделен терминал, на
  // който изходът да води до ПИН екрана.
  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <header
      className={`flex shrink-0 items-center justify-between gap-2.5 border-b border-shade-2 bg-surface ${
        isNarrow ? "min-h-12 px-4 py-2.5" : "min-h-[60px] px-7 py-[11px]"
      }`}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        <BackButton onClick={() => navigate("/monitoring")} />
        <img
          src="/logo-ts.png"
          alt="UnrealSoft"
          className={`shrink-0 select-none object-contain ${
            isNarrow ? "size-[26px]" : "size-[34px]"
          }`}
        />
        <div className="min-w-0 flex-1">
          <h1
            className={`m-0 truncate font-bold leading-[1.2] tracking-[-0.3px] text-ink ${
              isNarrow ? "text-[16px]" : "text-[18px]"
            }`}
          >
            {t("auditLog.title")}
          </h1>
          {isNarrow ? null : (
            <div className="mt-1 text-[11px] leading-none tracking-[0.3px] text-muted">
              {t("auditLog.subtitle")}
            </div>
          )}
        </div>
      </div>

      <div
        className={`flex shrink-0 items-center ${isNarrow ? "gap-1" : "gap-2.5"}`}
      >
        <button
          type="button"
          onClick={onRefresh}
          title={t("reportsPage.refresh")}
          aria-label={t("reportsPage.refresh")}
          className="grid size-[30px] place-items-center rounded-md text-muted transition-colors hover:bg-shade-1 hover:text-ink"
        >
          <ReloadOutlined
            className={`text-[14px] ${isFetching ? "animate-spin" : ""}`}
          />
        </button>
        {username ? (
          <ProfileDropdown
            displayName={displayName}
            username={username}
            access={access}
            isNarrow={isNarrow}
            onLogout={handleLogout}
          />
        ) : null}
      </div>
    </header>
  );
};
